export const IS_DEV = process.env.NODE_ENV === "development";

const RAW_TPS_HOST =
  process.env.REACT_APP_TPS_API_BASE_URL?.replace(/\/$/, "") ?? "";

// TPS
export const TPS_BASE = IS_DEV ? "/api/v1" : `${RAW_TPS_HOST}/api/v1`;

// REST
export const REST_BASE = IS_DEV ? "/rest" : `${RAW_TPS_HOST}/rest`;

// GEO
export const GEO_BASE = IS_DEV ? "/geo" : `${RAW_TPS_HOST}/geo`;

// POSROI
const RAW_POSROI_HOST =
  process.env.REACT_APP_POSROI_API_BASE_URL?.replace(/\/$/, "") ?? "";

export const POSROI_BASE = IS_DEV
  ? "http://localhost:8097/api/v1/PosRoi"
  : `${RAW_POSROI_HOST}/api/v1/PosRoi`;
